import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

/**
 * What is left of the old mapper page: the Job Updates queue. The suggestion
 * queue moved to `mapper_suggestions/data/api.js`.
 *
 * These four have callers outside this folder — the news feed's low-confidence
 * results and the publish popup — so they stay here rather than moving with the
 * tab.
 */

export const fetch_unmapped_job_updates = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('get_temp_job_updates'),
        params: data_params
    })
}

export const fetch_job_posts = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl("get_feed"),
        params: data_params
    })
}

export const map_and_post_job = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl("map_and_post_job"),
        data: data_params
    })
}

export const export_mapper_posts = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl("export_mapper_posts"),
        data: data_params
    })
}
